/**
 * Layout constants lifted from ds2.css so the MUI branches of the shared
 * wrappers land where their EUI counterparts do during coexistence.
 *
 * These exist only because both design systems are mounted at once — a migrated
 * form must not visibly reflow when its controls flip. Delete this module at
 * teardown along with the `*.eui` branches.
 */

/** `.euiFormRow` / `.euiFormControlLayout` cap; `fullWidth` lifts it. */
export const EUI_FORM_MAX_WIDTH = 400

/** `.euiFormRow--hasEmptyLabelSpace` — reserves the vertical space a label would take. */
export const EUI_EMPTY_LABEL_SPACE = { marginTop: 18, minHeight: 40 }
